import { DataSourceSetup, DataSourceType } from '@/models/dataSource';

export const generateCodeScript = (setupData: DataSourceSetup | undefined, dataSourceType: DataSourceType) => {
  if (!(setupData && setupData.setup && setupData.setup.scriptUrl)) {
    return undefined;
  }

  switch (dataSourceType.id) {
    case 'GOOGLE_TAG_MANAGER':
      return `
            <!-- Include 'analytics' from CDN -->
            <script src="${setupData?.setup.scriptUrl}"></script>
            <!--suppress JSUnresolvedVariable -->
            <script type="text/javascript">
            /* Initialize analytics */
            window.Analytics = CDPAnalytics.create({
                apiUrl: '${setupData?.setup.ingestionUrl}',
                datasourceId: "${setupData?.setup.datasourceId}",
                trackGoogleDataLayer: true,
                enabled: true
            });
            Analytics.page();
            </script>
        `;

    default:
      return `
        <!-- Include 'analytics' from CDN -->
        <script src="${setupData?.setup.scriptUrl}"></script>
        <!--suppress JSUnresolvedVariable -->
        <script type="text/javascript">
        /* Initialize analytics */
        window.Analytics = CDPAnalytics.create({
            apiUrl: '${setupData?.setup.ingestionUrl}',
            datasourceId: "${setupData?.setup.datasourceId}",
            enabled: true
        });

        Analytics.page();
        </script>
        `;
  }
};
